// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function CardV5(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: props.children,
      className: "flex grow flex-col p-5"
    }),
    className: TailwindMerge.twMerge([
      "rounded border bg-white shadow-sm border-zinc-300 flex flex-row md:flex-col",
      className
    ])
  });
}

let make = CardV5;

exports.make = make;
/* tailwind-merge Not a pure module */
